import { definePreset } from '@primevue/themes';
import Aura from '@primevue/themes/aura';

const CustomAura = definePreset(Aura, {
    semantic: {
        primary: {
            50: '#ECEFF1',
            100: '#CFD8DC',
            200: '#B0BEC5',
            300: '#90A4AE',
            400: '#78909C',
            500: '#607D8B',
            600: '#546E7A',
            700: '#455A64',
            800: '#37474F',
            900: '#263238',
            950: '#1C2327'
        }
    },    
    components: {
        button: {
            root: {
                paddingX: '0.75rem',
                paddingY: '0.75rem',
                transition: 'background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s'
            }
        },
        togglebutton: {
            root: {
                // Közös beállítások ha szükséges
            },
            colorScheme: {
                light: {
                    root: {
                        background: '#d9d9d9',
                        borderColor: '#d9d9d9', 
                        checkedBackground: '#d9d9d9',
                        checkedBorderColor: '#d9d9d9',
                    }
                }
            }
        }
    }
});

export default CustomAura;
